import React from "react";
import { Accordion, Card, Col } from "react-bootstrap";
import { IoMdCheckmark } from "react-icons/io";

import {
  formatDDMMYYYYbyYYYYMMDD,
  userDropdownLabel,
  employeeDropdownLabel,
} from "app/_helpers/helper";
import { Row } from "react-bootstrap";
import { TRAINING_TYPE_VIEW } from "./CONSTANTS";
import { DDMMYYYYFormat } from "app/_helpers/dateHelper";

const TrainingTimeline = ({ form }) => {
  const scheduledFlag = form?.scheduledDate ? true : false;
  const vtoFlag = form?.completionDate ? true : false;
  const soFlag = form?.soApproveDate ? true : false;
  const mmFlag = form?.mmApproveDate ? true : false;

  return (
    <div className="card p-3  pb-0 mt-4">
      <Row>
        <Col lg={12}>
          <Accordion defaultActiveKey={scheduledFlag ? "1" : "0"} className="timeline">
            <div
              className={`timelineSection ${
                scheduledFlag ? "completedtimelineSection" : "pendingtimelineSection"
              }`}
            >
              <Accordion.Toggle as={Card.Header} eventKey={scheduledFlag ? "1" : "0"}>
                <div
                  className={`number ${
                    scheduledFlag ? "completednumber" : "notstrtednumber"
                  }`}
                >
                  {scheduledFlag ? <IoMdCheckmark /> : 1}
                </div>
                <h4>Training Scheduled</h4>
              </Accordion.Toggle>

              <Accordion.Collapse eventKey="1">
                <div className="px-4 pt-0 timelineText">
                  <ul className="list-inline d-flex">
                    <li>
                      <div className="timelineRow">
                        <h5 className="txtgrey">Training Type</h5>
                        <h5>{TRAINING_TYPE_VIEW[form?.trainingType]}</h5>
                      </div>
                      <div className="timelineRow">
                        <h5 className="txtgrey">Due Date</h5>
                        <h5>{formatDDMMYYYYbyYYYYMMDD(form?.dueDate)}</h5>
                      </div>
                      <div className="timelineRow">
                        <h5 className="txtgrey">Name</h5>
                        <h5>{employeeDropdownLabel(form?.traineeData)}</h5>
                      </div>
                    </li>
                  </ul>
                </div>
              </Accordion.Collapse>
            </div>

            <div
              className={`timelineSection ${
                scheduledFlag ? "completedtimelineSection" : "pendingtimelineSection"
              }`}
            >
              <Accordion.Toggle as={Card.Header} eventKey={scheduledFlag ? "2" : "0"}>
                <div
                  className={`number ${
                    scheduledFlag ? "completednumber" : "notstrtednumber"
                  }`}
                >
                  {scheduledFlag ? <IoMdCheckmark /> : 2}
                </div>
                <h4>Batch Assigned</h4>
              </Accordion.Toggle>

              <Accordion.Collapse eventKey="2">
                <div className="px-4 pt-0 timelineText">
                  <ul className="list-inline d-flex">
                    <li>
                      <div className="timelineRow">
                        <h5 className="txtgrey">Training Type</h5>
                        <h5>{TRAINING_TYPE_VIEW[form?.trainingType]}</h5>
                      </div>
                      <div className="timelineRow">
                        <h5 className="txtgrey">Training Category</h5>
                        <h5>{form?.trainingCategoryData?.name}</h5>
                      </div>
                      <div className="timelineRow">
                        <h5 className="txtgrey">Training Date</h5>
                        <h5>{formatDDMMYYYYbyYYYYMMDD(form?.batchData?.trainingDate)}</h5>
                      </div>
                      <div className="timelineRow">
                        <h5 className="txtgrey">Batch Assigned On</h5>
                        <h5>{formatDDMMYYYYbyYYYYMMDD(form?.startDate)}</h5>
                      </div>
                    </li>
                  </ul>
                </div>
              </Accordion.Collapse>
            </div>

            <div
              className={`timelineSection ${
                vtoFlag ? "completedtimelineSection" : "pendingtimelineSection"
              }`}
            >
              <Accordion.Toggle as={Card.Header} eventKey={vtoFlag ? "3" : "0"}>
                <div
                  className={`number ${vtoFlag ? "completednumber" : "notstrtednumber"}`}
                >
                  {vtoFlag ? <IoMdCheckmark /> : 3}
                </div>
                <h4>VTO Review</h4>
              </Accordion.Toggle>

              <Accordion.Collapse eventKey="3">
                <div className="px-4 pt-0 timelineText">
                  <ul className="list-inline d-flex">
                    <li>
                      <div className="timelineRow">
                        <h5 className="txtgrey">Review Date</h5>
                        <h5>{formatDDMMYYYYbyYYYYMMDD(form?.completionDate)}</h5>
                      </div>
                      <div className="timelineRow">
                        <h5 className="txtgrey">Name</h5>
                        <h5>{userDropdownLabel(form?.vtoData)}</h5>
                      </div>
                    </li>
                  </ul>
                </div>
              </Accordion.Collapse>
            </div>

            <div
              className={`timelineSection ${
                soFlag ? "completedtimelineSection" : "pendingtimelineSection"
              }`}
            >
              <Accordion.Toggle as={Card.Header} eventKey={soFlag ? "4" : "0"}>
                <div
                  className={`number ${soFlag ? "completednumber" : "notstrtednumber"}`}
                >
                  {soFlag ? <IoMdCheckmark /> : 4}
                </div>
                <h4>Safety Officer Review</h4>
              </Accordion.Toggle>

              <Accordion.Collapse eventKey="4">
                <div className="px-4 pt-0 timelineText">
                  <ul className="list-inline d-flex">
                    <li>
                      <div className="timelineRow">
                        <h5 className="txtgrey">Review Date</h5>
                        <h5>{DDMMYYYYFormat(form?.soApproveDate)}</h5>
                      </div>
                      <div className="timelineRow">
                        <h5 className="txtgrey">Name</h5>
                        <h5>{userDropdownLabel(form?.soData)}</h5>
                      </div>
                    </li>
                  </ul>
                </div>
              </Accordion.Collapse>
            </div>

            <div
              className={`timelineSection ${
                mmFlag ? "completedtimelineSection" : "pendingtimelineSection"
              }`}
            >
              <Accordion.Toggle as={Card.Header} eventKey={mmFlag ? "5" : "0"}>
                <div
                  className={`number ${mmFlag ? "completednumber" : "notstrtednumber"}`}
                >
                  {mmFlag ? <IoMdCheckmark /> : 5}
                </div>
                <h4>Mines Manager Approval</h4>
              </Accordion.Toggle>

              <Accordion.Collapse eventKey="5">
                <div className="px-4 pt-0 timelineText">
                  <ul className="list-inline d-flex">
                    <li>
                      <div className="timelineRow">
                        <h5 className="txtgrey"> Approval Date</h5>
                        <h5>{DDMMYYYYFormat(form?.mmApproveDate)}</h5>
                      </div>
                      <div className="timelineRow">
                        <h5 className="txtgrey">Name </h5>
                        <h5>{userDropdownLabel(form?.mmData)}</h5>
                      </div>
                    </li>
                  </ul>
                </div>
              </Accordion.Collapse>
            </div>

            <div
              className={`timelineSection ${
                mmFlag ? "completedtimelineSection" : "pendingtimelineSection"
              } lastTimeLine`}
            >
              <Accordion.Toggle as={Card.Header} eventKey={mmFlag ? "6" : "0"}>
                <div
                  className={`number ${mmFlag ? "completednumber" : "notstrtednumber"}`}
                >
                  {mmFlag ? <IoMdCheckmark /> : 6}
                </div>
                <h4>Training Certificate Issued</h4>
              </Accordion.Toggle>

              <Accordion.Collapse eventKey="6">
                <div className="px-4 pt-0 timelineText">
                  <ul className="list-inline d-flex">
                    <li>
                      <div className="timelineRow">
                        <h5 className="txtgrey">No</h5>
                        <h5>{form?.certificateId}</h5>
                      </div>
                      <div className="timelineRow">
                        <h5 className="txtgrey">Date of Training</h5>
                        <h5>{DDMMYYYYFormat(form?.completionDate)}</h5>
                      </div>
                      <div className="timelineRow">
                        <h5 className="txtgrey">Issue Date </h5>
                        <h5>{formatDDMMYYYYbyYYYYMMDD(form?.mmApproveDate)}</h5>
                      </div>
                    </li>
                  </ul>
                </div>
              </Accordion.Collapse>
            </div>

            {/* <div
              className={`timelineSection ${
                vflCompletedFlag
                  ? "completedtimelineSection"
                  : "pendingtimelineSection"
              } lastTimeLine`}
            >
              <Accordion.Toggle as={Card.Header} eventKey="7">
                <div
                  className={`number ${
                    vflCompletedFlag ? "completednumber" : "notstrtednumber"
                  }`}
                >
                  {vflCompletedFlag && <IoMdCheckmark />}
                </div>
                <h4>Training Completed</h4>
              </Accordion.Toggle>

              <Accordion.Collapse eventKey="7">
                <div className="px-4 pt-0 timelineText">
                  <ul className="list-inline d-flex">
                    <li>
                      <div className="timelineRow">
                        <h5 className="txtgrey"> Date</h5>
                        <h5>
                          {formatDDMMYYYYbyYYYYMMDD(
                            form?.vflCompletionDateTime
                          )}
                        </h5>
                      </div>
                      <div className="timelineRow">
                        <h5 className="txtgrey">Name </h5>
                        <h5>
                          {form?.vflCompletedByData?.firstName}{" "}
                          {form?.vflCompletedByData?.lastName}
                        </h5>
                      </div>
                    </li>
                  </ul>
                </div>
              </Accordion.Collapse>
            </div> */}
          </Accordion>
        </Col>
      </Row>
    </div>
  );
};

export default TrainingTimeline;
